import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="border-line bg-surface-raised mt-auto border-t">
      <div className="max-w-content mx-auto flex flex-wrap items-center justify-between gap-4 px-4 py-6 max-md:flex-col max-md:text-center md:px-8">
        <span className="text-fg-muted text-[0.8125rem]">
          {t('footer.copyright')}
        </span>
        <div className="flex flex-wrap justify-center gap-6 max-md:gap-4">
          <a
            href="/privacy"
            className="text-fg-secondary duration-fast hover:text-accent text-[0.8125rem] transition-colors"
          >
            {t('footer.privacyPolicy')}
          </a>
          <a
            href="/terms"
            className="text-fg-secondary duration-fast hover:text-accent text-[0.8125rem] transition-colors"
          >
            {t('footer.termsOfService')}
          </a>
          <a
            href="/contact"
            className="text-fg-secondary duration-fast hover:text-accent text-[0.8125rem] transition-colors"
          >
            {t('footer.contact')}
          </a>
        </div>
      </div>
    </footer>
  )
}
